export default __webpack_public_path__ + "static/watches-7aeb6be015c5376665054bb1c591dbb2.png";